<template lang="pug">
  v-app
    v-content
      v-container
        v-layout(justify-center row fill-height)
          v-flex(xs12 sm8 md7 lg6 xl4)
            v-card(class="pa-3")
              v-progress-linear(
                  v-if="isPreloader",
                  :indeterminate="isPreloader",
                  height="3",
                  color="red")
              v-card-title(class="pb-0")
                span(class="display-1 d-inline-block mx-auto") Авторизация SMART-iD
              v-card-text
                v-layout(justify-center row)
                  v-flex(xs9 sm8 lg7 xl6)
                    v-img(:src="qrCode ? qrCode : '/static/images/id.png'")
</template>

<script>
export default {
  name: 'SmartId',
  mounted() {
    this.auth()
  },
  data: () => ({
    sessionServerUrl: 'https://sessionserver.onoi.kg',
    appName: 'DolborDB',
    qrCode: null,
    isPreloader: false,
    authorized: false
  }),
  destroyed() {
    this.qrCode = null
  },
  methods: {
    auth() {
      window.SmartId.initialize(
        this.sessionServerUrl,
        this.appName,
        newQrCode => {
          this.qrCode = newQrCode
        },
        authorizationData => {
          // console.log('authData', authorizationData)
          if (authorizationData.isConfirmed) {
            this.$store.dispatch('AUTH_WITH_SMART_ID', authorizationData.sessionId)
          }
        },
        () => {
          this.$store.dispatch('SET_LOGOUT')
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  margin-top: 100px;
  position: relative;
  .v-progress-linear {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SmartId/SmartId.vue